<script>
export default {
  name: "RealityAmplifyButton",
  data: () => ({
    isDoomed: false,
    isVisible: false,
    isDisabled: false,
    isActive: false,
    ratio: 1,
    canAmplify: false,
  }),
  computed: {
    tooltip() {
      if (this.isDoomed) return "Вы не можете усилить Обречённую Реальность";
      if (this.isDisabled) return "Вы не можете усилять Реальности Божеств";
      if (!this.canAmplify) {
        return "Накопите больше реального времени или завершите Реальность быстрее чтобы усилить";
      }
      return null;
    },
    buttonClass() {
      return {
        "l-reality-amplify-button": true,
        "l-reality-amplify-button--clickable": !this.isDoomed && this.canAmplify,
        "o-enslaved-mechanic-button--storing-time": this.isActive,
      };
    }
  },
  methods: {
    update() {
      this.isDoomed = Pelle.isDoomed;
      this.isVisible = Enslaved.isUnlocked;
      this.isDisabled = isInCelestialReality();
      this.isActive = Enslaved.boostReality;
      this.ratio = Enslaved.realityBoostRatio;
      this.canAmplify = Enslaved.canAmplify;
    },
    toggleActive() {
      if (!this.canAmplify) return;
      Enslaved.boostReality = !Enslaved.boostReality;
    }
  }
};
</script>

<template>
  <button
    v-if="isVisible"
    :class="buttonClass"
    :ach-tooltip="tooltip"
    @click="toggleActive"
  >
    <div v-if="isDoomed">
      Вы не можете усилять Обречённые Реальности.
    </div>
    <div v-else-if="canAmplify">
      <span v-if="isActive">Будет усилено:</span>
      <span v-else>Усилить эту Реальность:</span>
      <br>
      Все награды ×{{ formatInt(ratio) }}
    </div>
    <div v-else>
      Не хватает реального времени для усиления.
    </div>
  </button>
</template>

<style scoped>

</style>
